






































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
// Importing functions
import {putItem} from '@/ts/cart/put-item';
import {deleteItem} from '@/ts/cart/delete-item';
import {getCart} from '@/ts/cart/get-cart';
import {postItem} from '@/ts/cart/post-item';
// Importing an event bus
import {EventBus} from '@/ts/event-bus';

export default {
    name: 'ThePreviewCart',
    components: {
        BaseButton,
    },
    data() {
        return {
            data: Object(),
            options: Array(),
            quantity: Array(),
        };
    },
    mounted() {
        this.options = [1, 2, 3, 4, 5];
        getCart(this.$route.query.restaurant).then((response) => {
            this.data = response;
            for (const item of this.data.data) {
                this.$set(this.quantity, item.id, item.attributes.quantity);
            }
        });
    },
    created() {
        EventBus.$on('newItem', this.newItem);
    },
    destroyed() {
        EventBus.$off('newItem');
    },
    methods: {
        removeItem(id) {
            deleteItem(id, this.$route.query.restaurant).then((response) => {
                this.data = response;
                for (const item of this.data.data) {
                    this.$set(this.quantity, item.id, item.attributes.quantity);
                }
            });
        },
        refreshItem(event, id) {
            putItem(id, this.$route.query.restaurant, event).then((response) => {
                this.data = response;
                for (const item of this.data.data) {
                    this.$set(this.quantity, item.id, item.attributes.quantity);
                }
            });
        },
        newItem(data) {
            postItem(this.$route.query.restaurant, data).then((response) => {
                this.data = response;
                for (const item of this.data.data) {
                    this.$set(this.quantity, item.id, item.attributes.quantity);
                }
            });
        },
        submit() {
            this.$router.push({ path: '/cart?restaurant=' + this.$route.query.restaurant });
        },
    },
};
